import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicChangePassword = React.lazy(() => import(/* webpackChunkName: "dynamic-change-password" */ './DynamicChangePassword'));

componentService.registerPageComponents({ 'dynamic-change-password': DynamicChangePassword });
